<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="14"
    viewBox="0 0 12 15"
    fill="none"
  >
    <path
      d="M11.5 8.9L6 14.5L0.5 8.9M11.5 0.500001L6 6.1L0.5 0.5"
      stroke="#242424"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
